import initialState from '../app/initialstate';
import {API_ERRORS} from '../middlewares/api-middleware';
import {currentResource} from './utils/utils';

//#region Actions
export const CLIENT_VALIDATION_ERROR = 'app/errors/validation';
export const SUCCESS_MESSAGE = 'app/success';
export const WARNING_MESSAGE = 'app/warning';
export const INFO_MESSAGE = 'app/info';
export const CLEAR_ERRORS = 'app/errors/clear';

//#endregion

//#region Reducer
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function reducer(state = initialState.errors, action) {
	switch (action.type) {
		case API_ERRORS: {
			/* Notice that this is simply returning the action payload, <%=names.camel%>.
			 * This is because the combineReducers() call wraps this reducer
			 * and passes it only the portion of the store state that it
			 * is concerned with. */
			let errorResponse;
			const response = action?.error?.response;
			if (response) {
				const data = response?.data;
				if (data.errors && data.errors.Error) {
					errorResponse = data.errors.Error[0];
				} else if (data.Message) {
					errorResponse = data.Message;
				} else if (
					data.errors &&
					Object.getOwnPropertyNames(data.errors).length > 0
				) {
					const propName = Object.getOwnPropertyNames(data.errors)[0];
					if (Array.isArray(data.errors[propName])) {
						errorResponse = data.errors[propName][0];
					} else {
						errorResponse = response.statusText;
					}
				} else {
					errorResponse = response.statusText;
				}
			} else {
				errorResponse = action.error;
			}

			return errorResponse === undefined ? state : errorResponse;
		}
		case SUCCESS_MESSAGE:
			return {
				message: action.message,
				level: 'success'
			};
		case WARNING_MESSAGE:
			return {
				message: action.message,
				level: 'warning'
			};
		case INFO_MESSAGE:
			return {
				message: action.message,
				level: 'info'
			};
		case CLIENT_VALIDATION_ERROR:
			return {
				message: action.message,
				level: 'error'
			};
		case CLEAR_ERRORS:
			return {};
		default:
			return state;
	}
}
//#endregion

//#region Action creators
/**
 * Raise an error from JavaScript code. This is for validation failure
 * @param {String} message - entities hierarchy
 * @return {Object} the dispatch
 @return {Function} Thunk function
 */
export function raiseJSValidationError(errorCode) {
	return {
		type: CLIENT_VALIDATION_ERROR,
		message: errorCode
			.toString()
			.concat(' - ', currentResource.errors[errorCode] ?? errors['default'])
	};
}

export function raiseJSValidationErrorWithCount(errorCode, msgCount) {
	return {
		type: CLIENT_VALIDATION_ERROR,
		message: errorCode
			.toString()
			.concat(' - ', currentResource.errors[errorCode].replace('{0}', msgCount) ?? errors['default'])
	};
}

export function clearErrors() {
	return {
		type: CLEAR_ERRORS
	};
}
//#endregion
